var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCircleGear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C14.0711 15.5 15.75 13.8211 15.75 11.75C15.75 9.67893 14.0711 8 12 8C9.92893 8 8.25 9.67893 8.25 11.75C8.25 13.8211 9.92893 15.5 12 15.5Z",
    stroke: "#454D4F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9812 19.1913C6.54615 18.0806 7.40744 17.1478 8.46973 16.4963C9.53202 15.8448 10.7539 15.5 12 15.5C13.2462 15.5 14.468 15.8448 15.5303 16.4963C16.5926 17.1478 17.4539 18.0806 18.0189 19.1913",
    stroke: "#454D4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.25C19.5784 7.25 20.25 6.57843 20.25 5.75C20.25 4.92157 19.5784 4.25 18.75 4.25C17.9216 4.25 17.25 4.92157 17.25 5.75C17.25 6.57843 17.9216 7.25 18.75 7.25Z",
    stroke: "#454D4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 4.25V3.125",
    stroke: "#454D4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4511 5L16.4768 4.4375",
    stroke: "#454D4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4511 6.5L16.4768 7.0625",
    stroke: "#454D4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.25V8.375",
    stroke: "#454D4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0491 6.5L21.0233 7.0625",
    stroke: "#454D4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0491 5L21.0233 4.4375",
    stroke: "#454D4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9361 11.4219C20.9787 11.7797 21.0001 12.1397 21 12.5C21 14.28 20.4722 16.0201 19.4832 17.5001C18.4943 18.9802 17.0887 20.1337 15.4442 20.8149C13.7996 21.4961 11.99 21.6743 10.2442 21.3271C8.49836 20.9798 6.89472 20.1226 5.63604 18.864C4.37737 17.6053 3.5202 16.0016 3.17294 14.2558C2.82567 12.51 3.0039 10.7004 3.68509 9.05585C4.36628 7.41131 5.51983 6.00571 6.99987 5.01677C8.47991 4.02784 10.22 3.5 12 3.5C12.2816 3.5 12.56 3.51275 12.8352 3.53824",
    stroke: "#454D4F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleGear);
export default __webpack_public_path__ + "static/media/user_circle_gear.dc1d7439.svg";
export { ForwardRef as ReactComponent };